/**
 * @fileoverview Auth Service
 * @description Communicates with the backend auth endpoints.
 *              The backend only brokers the Ping token exchange
 *              (solving CORS). Tokens are returned to the frontend
 *              and stored in memory — the backend is stateless.
 * @module services/api/auth
 */

import { APP_CONFIG } from '@/config';

const AUTH_BASE = `${APP_CONFIG.api.baseUrl}/auth`;

/**
 * Redirect the browser to the backend login endpoint,
 * which will redirect to PingFederate.
 * @param {string} [returnUrl='/'] - Where to go after login
 */
export function redirectToLogin(returnUrl = '/') {
  const url = `${AUTH_BASE}/login?return_url=${encodeURIComponent(returnUrl)}`;
  window.location.href = url;
}

/**
 * Exchange a one-time code for actual tokens.
 * The backend deletes the code after this call — can only be used once.
 * @param {string} code - One-time code from the callback redirect
 * @returns {Promise<{access_token: string, user: object} | null>}
 */
export async function exchangeCode(code) {
  const resp = await fetch(`${AUTH_BASE}/exchange`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });
  if (!resp.ok) return null;
  return resp.json();
}

export const authApi = {
  redirectToLogin,
  exchangeCode,
};
